import { encode as base64_encode } from 'base-64';
import { postApi } from '../components/Utility'

import config from "../config";
import {
  action,

  makeObservable,
  observable,

} from 'mobx';


class IdleGraphStore {
    idleGraph=[]
  total = 0
  loading = false
  rootStore

  constructor(rootStore) {
    makeObservable(this, {
        idleGraph:observable, 
      total: observable,
      loading: observable,
      loadIdleGraphData: action,
    
      
    });
    this.rootStore = rootStore;

  }

  async loadIdleGraphData({ offset, limit,companyId,vehicleId,fromDate,toDate}) {
    this.loading = true;
    var postData = {"companyId":companyId,"vehicleId":vehicleId,"fromDate":fromDate,"toDate":toDate,"offset":0,"limit":15,"page":1,"isGraph":1}

    if(config.pythonReport === 1){
        // postData.companyId=10166
        // postData.vehicleId=27043
        var response = await postApi.getClient('report').post("/report/idle", postData);

    }else{
        const base64Input = await base64_encode(JSON.stringify(postData));
        response = await postApi.getClient().post("index.php?c=vehicleidle&a=idleGraph", "postData=" + base64Input);
    }

    // console.log("fuel detis ", response?.data?.data?.usagedata)
    var idleGraphData =response?.data?.data?.idlingReport
    if (idleGraphData && (idleGraphData)) {
        idleGraphData.forEach((element) => {
          const timeComponents = element.duration.split(":");
          const hours = parseInt(timeComponents[0], 10);
          const minutes = parseInt(timeComponents[1], 10);
          const seconds = parseInt(timeComponents[2], 10);
          const durationInMinutes = hours * 60 + minutes + seconds / 60;
          element.duration = durationInMinutes;
      });
    }
    this.idleGraph = idleGraphData
    return response?.data?.data?.idlingReport;
  }

  




 
}

export default IdleGraphStore;
